import { z } from 'zod';
import type { IpgBrowserTokenizationResult } from '../../types/ipg/ipg-browser-tokenization-result-registry';
import {
    CardPointeCardSecureBrowserTokenizationResultSchema,
    CardPointeCardSecureBrowserTokenizationResultV2Schema,
    CardPointeCardSecureHostedIframeTokenizationResultSchema,
    CardPointeCardSecureHostedIframeTokenizationResultV2Schema,
} from './cardpointe/cardpointe-tokenization.schemas';
import {
    CloverEcommerceBrowserTokenizationResultSchema,
    CloverEcommerceBrowserTokenizationResultV2Schema,
} from './clover/clover-tokenization.schemas';
import { ValorBrowserTokenizationResultV2Schema } from './valor/valor-payment.schemas';

export const IpgBrowserTokenizationResultSchema: z.ZodType<IpgBrowserTokenizationResult> =
    z.discriminatedUnion('result_type', [
        CardPointeCardSecureBrowserTokenizationResultSchema,
        CardPointeCardSecureBrowserTokenizationResultV2Schema,
        CardPointeCardSecureHostedIframeTokenizationResultSchema,
        CardPointeCardSecureHostedIframeTokenizationResultV2Schema,
        CloverEcommerceBrowserTokenizationResultSchema,
        CloverEcommerceBrowserTokenizationResultV2Schema,
        ValorBrowserTokenizationResultV2Schema,
    ]);
